import { PlanCard } from './PlanCard';

interface PlanSelectorProps {
  currentPlanKey?: string;
  shopId?: string;
  billingEnabled?: boolean;
  isBetaTester?: boolean;
}

const getPlans = (isBetaTester: boolean) => [
  {
    key: 'core',
    name: 'Core',
    price: '$349',
    betaNote: isBetaTester
      ? 'Beta program: 60 days free, then $174.50/mo for 12 months, then $349/mo.'
      : undefined,
    description: 'AI-powered scheduling and workflow intelligence for modern repair shops.',
    features: [
      'AI-Driven Smart Scheduling',
      'Dynamic Dispatch Optimization',
      'Waiter & Drop-Off Intelligence',
      'OptiLearn Engine',
      'Drag-and-Drop Dayboard',
      'Birdseye View Dashboard',
      'Multi-Bay & Rollover Support',
      'Live ETA & Job Timers',
      'CSV Import & Integration Ready',
      'Role-Based Access',
    ],
    available: true,
  },
  {
    key: 'catalyst',
    name: 'Catalyst',
    price: 'Coming Soon',
    description: 'Advanced coordination and optimization across bays, teams, and workloads.',
    features: [
      'Everything in Core, plus:',
      'Advanced team coordination',
      'Multi-location support',
      'Enhanced automation',
      'Premium support',
    ],
    available: false,
  },
  {
    key: 'enterprise',
    name: 'Enterprise',
    price: 'Custom',
    description: 'Built for MSOs, large chains, and corporate operations needing full integration.',
    features: [
      'Everything in Catalyst, plus:',
      'Enterprise features',
      'Custom integrations',
      'Dedicated support',
      'White-label options',
    ],
    available: false,
  },
];

export const PlanSelector = ({ currentPlanKey, shopId, billingEnabled = true, isBetaTester = false }: PlanSelectorProps) => {
  const plans = getPlans(isBetaTester);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {plans.map((plan) => (
        <PlanCard
          key={plan.key}
          plan={plan}
          isCurrent={currentPlanKey === plan.key}
          shopId={shopId}
          billingEnabled={billingEnabled}
          isBetaTester={isBetaTester}
        />
      ))}
    </div>
  );
};
